import { Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { EFidelityLevelMan, EFidelityLevelWoman, type FidelityLevel, Gender } from "../../hooks/auth/models"
import { GREEN_MAIN } from "../../theme/colors"

// Styled components
const HeaderItemContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding:"0 40px 0 0",

}))

const LevelBadge = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
}))

interface UserFidelityLevelHeaderProps extends FidelityLevel {
  username: string
}

export default function UserFidelityLevelHeader({ level, gender, username }: UserFidelityLevelHeaderProps) {
  // Get the level badge image based on level and gender
  const getLevelBadgeImage = (lvl: string, gender: Gender.male | Gender.female): string => {
    if (lvl === EFidelityLevelMan.PIONEER || lvl === EFidelityLevelWoman.PIONEER) {
      return "/01-pioneer.png"
    }

    if (gender === Gender.male) {
      switch (lvl) {
        case EFidelityLevelMan.LORD:
          return "/02-lord.png"
        case EFidelityLevelMan.KING:
          return "/03-king.png"
        default:
          return "/01-pioneer.png"
      }
    } else {
      switch (lvl) {
        case EFidelityLevelWoman.LADY:
          return "/02-lady.png"
        case EFidelityLevelWoman.QUEEN:
          return "/03-queen.png"
        default:
          return "/01-pioneer.png"
      }
    }
  }

  return (
    <HeaderItemContainer>
      <Typography
        // variant="body1"
        sx={{
          color: GREEN_MAIN,
          fontWeight: "medium",
          fontSize: "12px"
        }}
      >
        Ciao{"     "}
        <Box 
          component="span" 
          sx={{ 
            color: GREEN_MAIN, 
            fontWeight: "bold",
            fontSize: "12px",
            marginRight:'10px'
         }}>
          {username}
        </Box>
      </Typography>

      {/* //<LevelBadge> */}
        {/* <Typography
          variant="body2"
          sx={{
            color: GREEN_MAIN,
            fontSize: "12px",
            marginRight:'5px'
          }}
        >
          level:
        </Typography> */}
        {/* <Box
          component="img"
          src={getLevelBadgeImage(level, gender)}
          alt={`Level ${level}`}
          sx={{
            // width: 70,
            height:'50px',
            // objectFit: "contain",
          }}
        />
      </LevelBadge> */}
    </HeaderItemContainer>
  )
}
